/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PageLoader } from '@sumtotal/react-foundation';
import PropTypes from 'prop-types';
import authService from './AuthorizeService';
import { ApplicationPaths, QueryParameterNames } from './AuthorizationConstants';
import { toggleVisibility, postMessage } from '../modules/core/services/coreIFrameHelper';

export default class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      authenticated: false
    };
  }

  async componentDidMount() {
    this.subscription = authService.subscribe(() => this.authenticationChanged());
    await this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this.subscription);
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated });
  }

  render() {
    const { ready, authenticated } = this.state;
    const link = document.createElement('a');
    const { path } = this.props;
    const { location } = window;
    const returnUrl = `${location.protocol}//${location.host}${location.pathname}${location.search}${location.hash}`;
    link.href = path;
    const redirectUrl = `${ApplicationPaths.Login}?${
      QueryParameterNames.ReturnUrl
    }=${encodeURIComponent(returnUrl)}`;
    if (!ready) {
      return <PageLoader show />;
    }
    const { component: RouteComponent, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          if (authenticated) {
            // If navigating to rcore route then hide the iframe
            if (location.pathname === '/rcore/c') {
              // Rerouting the /c to /c/
              location.assign('/rcore/c/');
              return;
            }
            if (rest.path !== '/' && rest.path !== '/c') {
              postMessage('CLOSE_CURRENT_SLIDEOUT');
              toggleVisibility(false);
              return (
                <div>
                  <RouteComponent {...props} />
                </div>
              );
            }
            return <RouteComponent {...props} />;
          }
          return <Redirect to={redirectUrl} />;
        }}
      />
    );
  }
}

AuthorizeRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.shape({}).isRequired
};
